<div class="col-sm-2">
  <div id="dots3">
    <span [style.background]="dotsColor"></span>
    <span [style.background]="dotsColor"></span>
    <span [style.background]="dotsColor"></span>
    <span [style.background]="dotsColor"></span>
  </div>
</div>
